import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Caption, Title4 } from "@components/Typography";
import { useStyles } from "./styles";
import { ListItemProps } from "./types";

export const ListItem = ({ label, right, error }: ListItemProps) => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      <Row>
        <Title4 style={styles.title}>{label}</Title4>
        {right}
      </Row>
      {error ? (
        <>
          <Spacing size={SpacingSizes.XXS} />
          <Caption style={styles.error}>{error}</Caption>
        </>
      ) : null}
    </div>
  );
};
